import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	faqRoot: {
		padding      : "2rem",
		height       : "100%",
		borderRadius : "inherit"
	},
	contentDiv: {
		margin        : "2rem 0",
		display       : "flex",
		flexDirection : "column",
		gap           : "2rem"
	},
	faqTitle: {
		fontWeight : "500",
		fontSize   : "1.6rem"
	},
	faqQuestion: {
		cursor        : "pointer",
		alignItems    : "center",
		display       : "flex",
		borderBottom  : `1px solid ${ theme.other.colors.border.primary }`,
		marginTop     : "0.5rem",
		paddingBottom : "0.6rem",
		"&:hover"     : {
			fontWeight: "500"
		},
		"&:last-of-type": {
			borderBottom: "none"
		}
	},
	openIcon: {
		marginLeft : "auto",
		opacity    : props?.hovered ? "1" : "0",
		transform  : "scale( 1.5 )",
		color      : "initial !important",
		transition : "opacity 0.2s ease"
	}
} ) );

